import { useEffect, useState } from 'react';

import { getCountryCode } from './get-country-code';

export async function fetchUserIsCoveredByGdpr(): Promise<boolean> {
  try {
    const countryCode = await getCountryCode();
    const isCoveredByGDPR = gdprCountryCodes.includes(countryCode);
    return isCoveredByGDPR;
  } catch (error) {
    console.error(
      `Functional error: Unable to detect user's country code: ${JSON.stringify(
        error,
      )}`,
    );
    //fail gracefully if we are unable to detect user's country code;
    return true;
  }
}

const gdprCountryCodes = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CH',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SG',
];

export function useStartTrackingIfOutsideGDPR(startTracking: () => void) {
  const [isCoveredByGdpr, setIsCoveredByGdpr] = useState(true);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchUserIsCoveredByGdpr()
      .then(setIsCoveredByGdpr)
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    if (!isCoveredByGdpr) {
      startTracking();
    }
  }, [isCoveredByGdpr]);
  return { loading, isCoveredByGdpr };
}
